import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
// @ts-expect-error TS2339: Property 'dataLayer' does not exist on type 'Window & typeof globalThis'.
let isGTagAvailable = typeof window.gtag === 'function' && Array.isArray(window.dataLayer);
if (isGTagAvailable) {
    try {
        // @ts-expect-error TS7006: Parameter 'layer' implicitly has an 'any' type.
        const trackingConfig = window.dataLayer.filter((layer) => layer[0] === 'config' && /^UA-/.test(layer[1]))[0];
        isGTagAvailable = trackingConfig && !!trackingConfig[1].match(/^UA-[0-9]+/);
    }
    catch (event) {
        console.log(event);
    }
}
else {
    isGTagAvailable = false;
}
const mockGTag = (...event) => {
    console.log('%cGTAG event', 'color: blue; font-weight: bold', ...event);
};
// @ts-expect-error TS2339: Property 'gtag' does not exist on type 'Window & typeof globalThis'.
const windowGTag = (...event) => window.gtag(...event);
export const gtag = isGTagAvailable ? windowGTag : mockGTag;
export default (WrappedComponent) => {
    return class withGTag extends React.Component {
        render() {
            return _jsx(WrappedComponent, { ...this.props, gtag: gtag });
        }
    };
};
